import { render, staticRenderFns } from "./Onsale.vue?vue&type=template&id=4148829e&scoped=true&"
import script from "./Onsale.vue?vue&type=script&lang=js&"
export * from "./Onsale.vue?vue&type=script&lang=js&"
import style0 from "./Onsale.vue?vue&type=style&index=0&id=4148829e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148829e",
  null
  
)

export default component.exports